export interface MessageTypes {
    SUCCESS: 0;
    VALIDATION_ERROR: 1;
    SERVER_ERROR: 2;
    LOG: 3;
    INFO: 4;
}

export interface ModelStatuses {
    SUCCESS: 200 | 201 | 0;
    ERROR: 100;
}

export const RESPONSE_STATUS_ERROR = 100; // ModelStatuses.ERROR's literal value, named so nothing checks a bare 100

export interface BaseResponse<T> {
    status: ModelStatuses[keyof ModelStatuses];
    response: T;
    messages: { message: string; type: MessageTypes[keyof MessageTypes] }[];
    errors?: unknown[];
}
